!function ($, global) {
    'use strict';

    var document = global.document;
    var body = document.body;
    var userAgent = global.navigator.userAgent;

    var $html = $('html');
    var $document = $(document);
    var $body = $(body);

    var isMobile = $('meta[name=ismobile]').prop('content') === 'true';

    // Add iOS Safari flag class
    if (isMobile && userAgent.match(/iP(hone|ad)/) && userAgent.match(/Safari/)) {
        $html.addClass('is-ios-safari');
    }

    // Reactive Images Init
    if($.reactiveImages) {
        $.reactiveImages({
            lazyload: {
                offset: '200%'
            }
        });
    }

    // Init page
    function init() {
        $body.removeClass('body-hidden');
        $(global).trigger('forcepaperjsresize');
    }

    // Wait for Visual Composer full width rows initialize if exists
    if ($('[data-vc-full-width-init="false"]').length) {
        $document.on('vc-full-width-row', init);
    } else {
        init();
    }

    // Remove focus outline after links and buttons clicked
    $document.on('mouseup', 'button', function () {
        $(this).blur();
    })

}(jQuery, window);